import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
  Typography,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import PrintIcon from "@mui/icons-material/Print";
import ReactToPrint from "react-to-print";
import "../../utils/printStyle.css";
import { getData } from "../../../../services/library";
import { ENDPOINTS } from "../../config/endpoints";
const ImprimirCorrectivo = ({ open, onClose, rowData }) => {
  const [correctivo, setCorrectivo] = useState([]);
  const [loading, setLoading] = useState(true);
  const componentRef = useRef();

  useEffect(() => {
    const getCorrectivoByID = async () => {
      setLoading(true);
      try {
        await getData(
          `${ENDPOINTS.CORRECTIVOS.BASE}/byid/${rowData?.id_correctivo}`,
          setCorrectivo
        );
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    if (rowData?.id_correctivo) getCorrectivoByID();
  }, [rowData?.id_correctivo]);
  console.log("correctivo", correctivo);

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle>Vista previa de impresión</DialogTitle>
      <DialogContent>
        <Grid container justifyContent="space-between" mb={2}>
          <ReactToPrint
            trigger={() => (
              <Button
                style={{ backgroundColor: blueGrey[400], color: "white" }}
                endIcon={<PrintIcon />}
              >
                Imprimir
              </Button>
            )}
            content={() => componentRef.current}
          />
          <Button onClick={onClose} variant="outlined" color="error">
            Cerrar
          </Button>
        </Grid>

        <div ref={componentRef}>
          <Paper style={{ padding: 16 }}>
            <Grid container justifyContent="space-evenly" mb={2}>
              <Typography variant="h6">Planta: {rowData?.planta}</Typography>
              <Typography variant="h6">
                Correctivo N°: {rowData?.id_correctivo}
              </Typography>
              <Typography variant="h6">Preparo: {rowData?.preparo}</Typography>
            </Grid>

            {loading ? (
              <CircularProgress />
            ) : (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Equipo</TableCell>
                    <TableCell>Tarea</TableCell>
                    <TableCell>Zona</TableCell>
                    <TableCell>Sector</TableCell>
                    <TableCell>Vencimiento</TableCell>
                    <TableCell>Observaciones OT</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {correctivo.map((row) => (
                    <TableRow key={row.id_correctivo}>
                      <TableCell>{row.equipo}</TableCell>
                      <TableCell>{row.tarea}</TableCell>
                      <TableCell>{row.zona}</TableCell>
                      <TableCell>{row.sector}</TableCell>
                      <TableCell>{row.vencimiento}</TableCell>
                      <TableCell>{row.observacionesOT}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>

                <TableRow sx={{ backgroundColor: "#f5f5f5", marginTop: 2 }}>
                  <TableCell>Horas</TableCell>
                  <TableCell>Costo Materiales</TableCell>
                  <TableCell>Costo Otros</TableCell>
                  <TableCell>Observaciones</TableCell>
                  <TableCell>Ejecuto</TableCell>
                </TableRow>

                <TableBody sx={{ marginTop: 2 }}>
                  {correctivo.map((row) => (
                    <TableRow key={row.id_correctivo + "_detalles"}>
                      <TableCell>{row.hrshombre}</TableCell>
                      <TableCell>{row.costo_materiales}</TableCell>
                      <TableCell>{row.otros_costos}</TableCell>
                      <TableCell>{row.observaciones}</TableCell>
                      <TableCell>{row.ejecuto}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </Paper>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImprimirCorrectivo;
